/**
 * 国际化配置文件
 * ch:中文
 * en:英文
 */
 export default {
    LogsMessage: { SC:"日志信息", TC: "日誌資訊", EN: "Log" }
    ,cancel: { SC:"取消", TC: "取消", EN: "Cancel" }
    ,createPeople: { SC:"创建人", TC: "創建人", EN: "Created By" }
    ,createTime: { SC:"创建时间", TC: "創建時間", EN: "Created Date" }
    ,lastUpdatedBy: { SC:"最后修改人", TC: "最後修改人", EN: "Last Updated By" }
    ,lastUpdatedTime: { SC:"最后修改时间", TC: "最後修改時間", EN: "Last Updated Date" }
}